import React from 'react';
import {
  Typography,
  Box,
  Alert,
  AlertTitle,
} from '@mui/material';
import { Warning } from '@mui/icons-material';

export function WhyMigrateCRATab() {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        <Warning sx={{ mr: 1 }} />
        Why Migrate from Create React App?
      </Typography>

      <Alert severity="warning" sx={{ mb: 3 }}>
        <AlertTitle>Create React App is No Longer Recommended</AlertTitle>
        The React team officially announced that CRA is no longer the recommended way to start new React projects.
      </Alert>

      <Typography variant="body1" sx={{ mb: 3 }}>
        Read the official announcement from the React team:
      </Typography>

      <Box sx={{ 
        border: 1, 
        borderColor: 'divider', 
        borderRadius: 1,
        overflow: 'hidden',
        height: '600px',
        mb: 3
      }}>
        <iframe
          src="https://react.dev/blog/2025/02/14/sunsetting-create-react-app"
          width="100%"
          height="100%"
          style={{ border: 'none' }}
          title="React.dev - What's Next for Create React App"
        />
      </Box>

      <Typography variant="h6" gutterBottom>
        Key Reasons to Migrate:
      </Typography>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Alert severity="info">
          <AlertTitle>🚀 Performance</AlertTitle>
          Modern tools like Vite offer significantly faster development builds and hot module replacement.
        </Alert>

        <Alert severity="info">
          <AlertTitle>🔧 Maintenance</AlertTitle>
          CRA maintenance has slowed down, with fewer updates and longer response times to issues.
        </Alert>

        <Alert severity="info">
          <AlertTitle>⚡ Modern Features</AlertTitle>
          New tools support latest ECMAScript features, better tree-shaking, and modern bundling techniques.
        </Alert>

        <Alert severity="info">
          <AlertTitle>🎯 Flexibility</AlertTitle>
          Modern alternatives offer more configuration options while maintaining ease of use.
        </Alert>

        <Alert severity="info">
          <AlertTitle>📦 Ecosystem</AlertTitle>
          Better integration with modern tooling ecosystem and deployment platforms.
        </Alert>
      </Box>
    </Box>
  );
}
